module.exports = __webpack_public_path__ + "img/facebook-logo.02cc09fc.svg";